<template>
  <VDialogV3
    id="add-production-position-popup"
    ref="dialog"
    class="content-block-style"
    title="Добавить позицию"
    :loading="false"
  >
    <section>
      <VInput
        v-model="localPosition.code"
        label="Код"
        layout="vertical"
        required
        @input="fetchProductName"
      >
        <template #helper-text>
          {{ productName ? productName : 'Введите код товара' }}
        </template>
      </VInput>

      <VSelect
        v-model="localPosition.productionSite"
        label="Производственная площадка"
        layout="vertical"
        :options="ProductionPageService.productionSiteOptions"
        :clearable="false"
        required
      />

      <VInputNumber
        v-for="month in monthLabels"
        :key="month.key"
        v-model="localPosition[month.key]"
        class="month-input"
        layout="vertical"
        :label="month.label"
        :min="0"
      />
    </section>

    <template #footer>
      <VButton
        :disabled="isLoading"
        theme="primary"
        @click="addPosition"
      >
        Добавить
      </VButton>
    </template>
  </VDialogV3>
</template>

<script>

import ProductionPlansService from '@/domains/ProductionPlans/ProductionPlansService.js';
import GlobalLoader           from '@/core/services/GlobalLoader/GlobalLoader.js';

export default {
  name: 'AddProductionPositionPopup',

  props: {
    monthKeys: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      ProductionPageService: ProductionPlansService,
      localPosition:         {},
      productName:           '',
    };
  },

  computed: {
    isLoading() {
      return GlobalLoader.isVisible;
    },
    monthLabels() {
      return this.monthKeys.map(key => ({
        key,
        label: `${this.ProductionPageService.formatMonthLabel(key).month} ${this.ProductionPageService.formatMonthLabel(key).year}`,
      }));
    },
  },

  methods: {
    fetchProductName() {
      if (!this.localPosition.code) return;

      this.ProductionPageService.getProductName({ code: this.localPosition.code })
        .then(name => {
          this.productName = name;
        })
        .catch(() => {
          this.productName = 'Товар не найден';
        });
    },

    async addPosition() {
      const isValid = await this.$refs.dialog.validate();

      if (!isValid) {
        return;
      }

      const data = this.monthKeys
        .filter(key => this.localPosition[key])
        .map(key => {
          return {
            plannedArrivalDate: key,
            qty: this.localPosition[key],
          };
        });

      const payload = {
        productionSiteId: this.localPosition.productionSite.id,
        productCode:      this.localPosition.code,
        data,
      };

      this.ProductionPageService.addProducts(payload).then(() => {
        this.$core.dialogs.AddProductionPositionPopup.resolve(true);
      });
    },
  },
};
</script>
